module.exports = __webpack_public_path__ + "static/media/Tanzania-Queen-and-Son-small-desktop.97332eb1.jpg";